import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { UpsellPurchaseToast } from '../components/UpsellPurchaseToast';
import { Footer } from '../components/Footer';
export function Upsell1InmunidadPage() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-10 md:pt-16" data-id="element-928">
      <main className="max-w-3xl mx-auto px-4 pb-20" data-id="element-929">
        <motion.section {...fadeIn} className="text-center py-10 md:py-16" data-id="element-930">
          <Shield className="w-16 h-16 text-[#2E7D32] mx-auto mb-6" data-id="element-931" />
          <h1 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-4" data-id="element-932">
            Oferta Especial — Inmunidad
          </h1>
          <p className="text-xl text-gray-600 italic" data-id="element-933">
            Contenido próximamente...
          </p>
        </motion.section>

        <motion.section {...fadeIn} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 mb-12 text-center" data-id="element-934">
          <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-935">
            Esta página está en construcción. Pronto tendrás contenido exclusivo
            aquí.
          </p>
        </motion.section>
      </main>

      <Footer data-id="element-936" />
      <UpsellPurchaseToast data-id="element-937" />
    </div>;
}